/**
 * Token storage abstraction layer.
 *
 * Currently uses sessionStorage (scoped to tab, cleared on close).
 * This is safer than localStorage because:
 * - Token is not shared across tabs (limits blast radius of XSS)
 * - Token is cleared when the browser tab/window closes
 *
 * Future: migrate to httpOnly cookie set by the backend /Token endpoint.
 * That would make the token completely invisible to JavaScript.
 */

const TOKEN_KEY = 'unilinkApiToken';
const USER_KEY = 'unilinkApiUser';

export const getToken = () => {
  return sessionStorage.getItem(TOKEN_KEY) || localStorage.getItem(TOKEN_KEY);
};

export const getUser = () => {
  return sessionStorage.getItem(USER_KEY) || localStorage.getItem(USER_KEY);
};

export const setToken = (token) => {
  sessionStorage.setItem(TOKEN_KEY, token);
  // Keep localStorage as fallback during migration — remove once stable
  localStorage.setItem(TOKEN_KEY, token);
};

export const setUser = (user) => {
  sessionStorage.setItem(USER_KEY, user);
  localStorage.setItem(USER_KEY, user);
};

export const clearTokens = () => {
  sessionStorage.removeItem(TOKEN_KEY);
  sessionStorage.removeItem(USER_KEY);
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
};
